import { Box, Button } from '@chakra-ui/react';
import { useEffect } from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetOneService } from 'shared/api/requests/services';
import Card from 'shared/components/horizon-ui/card/Card';
import { HSeparator } from 'shared/components/horizon-ui/separator/Separator';
import Link from 'shared/components/Link';


import useGetColors from 'shared/hooks/useGetColors';
import { ModuleE, PathsE, PathsParams } from "shared/routes";
import { fillFormErrors } from 'shared/utils/devUtils';
import Form from './Form';
import PageTitle from 'shared/views/admin/PageTitle';
import { useBlackListService } from "../../../api/requests/blackList";
import { CreateBlackListItem } from "../../../api/types/blacklist";
import {
  createBlackListItemResolver,
  getCreateBlackListItemValues,
} from "../../../form-values/blackList";

const Update = () => {
  const { t } = useTranslation();
  const { serviceId } = useParams<PathsParams[PathsE.CREATE_BLACKLIST_ITEM]>();
  console.log('serviceId', serviceId);
  const { gray800, white, gray100, brand500, brand400 } = useGetColors();

  const { data: currentService } = useGetOneService({
    pathParams: { serviceId },
    params: undefined
  });

  const { useCreateBlackListItem } = useBlackListService({
    domain: currentService?.domain,
    token: currentService?.token,
    module: ModuleE.BLACKLIST
  });
  
  const { mutate } = useCreateBlackListItem({
    pathParams: { serviceId },
    params: undefined
  });


  const methods = useForm<CreateBlackListItem['request']>({
    defaultValues: getCreateBlackListItemValues(),
    resolver: createBlackListItemResolver,
    mode: "onChange",
  });
  const { formState: { isValid }, trigger } = methods;

  useEffect(() => {
    trigger();
  }, []);
  

  const onSubmit: SubmitHandler<CreateBlackListItem['request']> = (values) => {
    mutate({
      telegram_id: values.telegram_id,
    }, { onError: (error) => fillFormErrors(methods.setError, error) })
  };

  const breadcrumbs = [
    {
      path: PathsE.HOME,
      text: t('general.home'),
    },
    {
      path: PathsE.BLACKLIST,
      text: t('services.blackList'),
      pathsParams: {
        serviceId,
      },
    },
  ];
  

  return (
    <Box>
      <PageTitle
        title={'Add Black List Item'}
        breadcrumbs={breadcrumbs}
        backUrl={{
          path: PathsE.BLACKLIST,
          pathsParams: {
            serviceId,
          }
        }}
      />
      <Card mb="20px" borderRadius="20px" px="30px">
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <Form />
            <HSeparator my="20px" mx="-20px" width="calc(100% + 40px)" />
            <Link<PathsParams[PathsE.BLACKLIST]> path={PathsE.BLACKLIST} pathsParams={{ serviceId }}>
              <Button
                color={gray800}
                bgColor={gray100}
                borderRadius="8px"
                w="100px"
              >
                {t('buttons.cancel')}
              </Button>
            </Link>
            <Button
              color={white}
              _hover={{
                bgColor: brand400,
              }}
              bgColor={brand500}
              borderRadius="8px"
              ml="20px"
              w="100px"
              type="submit"
              isDisabled={!isValid}
            >
              {t('buttons.create')}
            </Button>
          </form>
        </FormProvider>
      </Card>
    </Box>
  );
};

export default Update;
